import { render, staticRenderFns } from "./IconTitle.vue?vue&type=template&id=52b876b1&scoped=true"
import script from "./IconTitle.vue?vue&type=script&lang=js"
export * from "./IconTitle.vue?vue&type=script&lang=js"
import style0 from "./IconTitle.vue?vue&type=style&index=0&id=52b876b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b876b1",
  null
  
)

export default component.exports